import { render, staticRenderFns } from "./our-app-page-info.html?vue&type=template&id=4a209a46&scoped=true&external"
import script from "./our-app-page-info.js?vue&type=script&lang=js&external"
export * from "./our-app-page-info.js?vue&type=script&lang=js&external"
import style0 from "./our-app-page-info.scss?vue&type=style&index=0&id=4a209a46&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a209a46",
  null
  
)

export default component.exports